import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-indicator-wiz-visuals-unset-confirm-dialog',
  templateUrl: './indicator-wiz-visuals-unset-confirm-dialog.component.html',
  styleUrls: ['./indicator-wiz-visuals-unset-confirm-dialog.component.css']
})
export class IndicatorWizVisualsUnsetConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: IndicatorWizardDialogData) { }
}

export interface IndicatorWizardDialogData{
  title: string;
  workbookName: string;
  message: string;
}
